/* ============================================================================
 * LoadingState.tsx - Loading UI component for ProjectDataContext
 * ============================================================================ */

import React from 'react';
import { useSettings } from '@/features/settings/contexts/SettingsContext';

/**
 * Loading state component displayed while project data is being fetched
 */
export const LoadingState: React.FC = () => {
  const { t } = useSettings();
  return (
    <div className="flex h-screen items-center justify-center bg-zinc-50 text-zinc-700 dark:bg-zinc-950 dark:text-zinc-300">
      <div className="text-center">
        <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-2 border-zinc-300 border-t-zinc-800 dark:border-zinc-700 dark:border-t-zinc-100" />
        <p className="text-sm text-zinc-500 dark:text-zinc-400">{t('Loading project data...')}</p>
      </div>
    </div>
  );
};
